import { gql } from 'apollo-angular';

const GET_RFP_CATEGORIES = gql`
  query GetRfpCategories($rfpId: Long) {
    rfp(id: $rfpId) {
      categories {
        id
        name
        carvedInProductCount
        categorySelectionState
        coveredByRfpRecipient
        sellerCount
        parentId
        parents {
          id
          name
          type
          level
        }
        hierarchy
        actualSpend
        continuedSpend
        spend {
          actualSpend
          annualizedActualSpend
        }
        sellerSpend {
          actualSpend
          annualizedActualSpend
          marketShare
          annualizedMarketShare
        }
        potentialSavings {
          savingsVolume
          buyerEfficiencyStarCount
          buyerEfficiency
        }
      }
    }
  }
`;

export default GET_RFP_CATEGORIES;
